import React, { useState } from "react";
import toast from "react-hot-toast";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";

const SUPPORT_CHANNELS = [
  {
    icon: EmailOutlinedIcon,
    title: "Email Support",
    description: "Send detailed questions to support.",
    contact: "support@kkisanfresh.com",
    action: () => (window.location.href = "mailto:support@kkisanfresh.com"),
  },
  {
    icon: PhoneOutlinedIcon,
    title: "Call Us",
    description: "Speak with the support team.",
    contact: "+91 1234 567 890",
    action: () => (window.location.href = "tel:+911234567890"),
  },
  {
    icon: ChatOutlinedIcon,
    title: "Live Chat",
    description: "Quick help for common issues.",
    contact: "Chat now",
    action: () => toast.success("Live chat feature coming soon"),
  },
  {
    icon: DescriptionOutlinedIcon,
    title: "FAQ",
    description: "Read common answers below.",
    contact: "View FAQs",
    action: () => document.getElementById("account-faqs")?.scrollIntoView(),
  },
];

const FAQS = [
  {
    question: "How do I track my order?",
    answer:
      'You can track your order from the "Track Order" section in your account or using the order ID from your confirmation email.',
  },
  {
    question: "What is your refund policy?",
    answer:
      "Contact our support team within 7 days of delivery if you are not satisfied with the product.",
  },
  {
    question: "How long does delivery take?",
    answer:
      "Standard delivery takes 3-5 business days. Express delivery options are available in select areas.",
  },
  {
    question: "Are your products organic?",
    answer:
      "Products are sourced directly from farms and producers. Check each product page for specific details.",
  },
  {
    question: "Do you offer bulk orders?",
    answer:
      "For bulk orders, contact the sales team at sales@kkisanfresh.com with your requirements.",
  },
];

const HelpSection = () => {
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  return (
    <div>
      <div className="mb-5 border-b border-gray-200 pb-4">
        <h1 className="text-lg font-semibold text-gray-900">
          Help & Support
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Contact support or read answers to common questions.
        </p>
      </div>

      <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {SUPPORT_CHANNELS.map((channel) => {
          const Icon = channel.icon;
          return (
            <button
              key={channel.title}
              onClick={channel.action}
              className="rounded-lg border border-gray-200 p-4 text-left hover:bg-gray-50"
            >
              <Icon className="text-gray-500" style={{ fontSize: 22 }} />
              <h2 className="mt-3 text-sm font-semibold text-gray-900">
                {channel.title}
              </h2>
              <p className="mt-1 text-sm text-gray-500">
                {channel.description}
              </p>
              <p className="mt-2 break-words text-sm font-medium text-primary-700">
                {channel.contact}
              </p>
            </button>
          );
        })}
      </div>

      <div id="account-faqs" className="mb-6 rounded-lg border border-gray-200">
        <div className="border-b border-gray-200 px-4 py-3">
          <h2 className="text-sm font-semibold text-gray-900">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="divide-y divide-gray-200">
          {FAQS.map((faq, index) => (
            <div key={faq.question}>
              <button
                type="button"
                onClick={() =>
                  setExpandedFAQ(expandedFAQ === index ? null : index)
                }
                className="flex w-full items-center justify-between gap-4 px-4 py-3 text-left hover:bg-gray-50"
              >
                <span className="text-sm font-medium text-gray-900">
                  {faq.question}
                </span>
                <span className="shrink-0 text-gray-500">
                  {expandedFAQ === index ? "-" : "+"}
                </span>
              </button>
              {expandedFAQ === index && (
                <div className="px-4 pb-4 text-sm leading-6 text-gray-600">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <form
        className="rounded-lg border border-gray-200 p-4"
        onSubmit={(event) => {
          event.preventDefault();
          toast.success("Message sent");
        }}
      >
        <h2 className="mb-4 text-sm font-semibold text-gray-900">
          Send a Message
        </h2>
        <div className="space-y-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">
              Subject
            </label>
            <input
              type="text"
              required
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
              placeholder="What can we help you with?"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">
              Message
            </label>
            <textarea
              rows="5"
              required
              className="w-full resize-y rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
              placeholder="Tell us more details"
            />
          </div>
          <button
            type="submit"
            className="rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white hover:bg-primary-700"
          >
            Send Message
          </button>
        </div>
      </form>
    </div>
  );
};

export default HelpSection;
